<template>
  <transition name="fade">
    <button
      v-if="visible"
      class="back-to-top"
      title="Retour en haut"
      @click="scrollTop">
      <v-icon color="white">
        mdi-arrow-up
      </v-icon>
    </button>
  </transition>
</template>

<script>
  const THRESHOLD = 400

  // Suit la zone qui défile (la page ou le tableau d'une liste) et propose d'y remonter
  export default {
    name: 'BackToTop',
    data () {
      return {
        visible: false,
        target: null
      }
    },
    watch: {
      $route () {
        this.visible = false
        this.target = null
      }
    },
    mounted () {
      document.addEventListener('scroll', this.onScroll, true)
    },
    beforeDestroy () {
      document.removeEventListener('scroll', this.onScroll, true)
    },
    methods: {
      onScroll (event) {
        const el = event.target === document ? document.scrollingElement : event.target
        if (!el || el.scrollHeight <= el.clientHeight) return
        if (el.scrollTop > THRESHOLD) {
          this.target = el
          this.visible = true
        } else if (el === this.target) {
          this.visible = false
        }
      },
      scrollTop () {
        if (this.target) this.target.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
</script>

<style scoped>
  .back-to-top {
    position: fixed;
    right: 28px;
    bottom: 76px;
    z-index: 20;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #111113;
    box-shadow: 0 6px 18px rgba(17, 17, 19, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .back-to-top:hover {
    background: #000000;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
